import { connect } from 'react-redux';
import { authWithTwitchToken } from 'services/auth-legacy';
import TwitchLoginButton from './TwitchLoginButton';

const mapDispatchToProps = dispatch => ({
  onTwitchCallback: object => dispatch(authWithTwitchToken(object)),
});

export default connect(mapDispatchToProps)(TwitchLoginButton);
